import { AfterViewInit, Component, OnInit, QueryList, ViewChildren, ViewEncapsulation, OnDestroy } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { AutoResume, DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import * as moment from 'moment';
import { ToastData, ToastOptions, ToastyConfig, ToastyService } from "ng2-toasty";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { LoginComponent } from "../components/login/login.component";
import { Permission } from "../models/permission.model";
import { AccountService } from "../services/account.service";
import { AlertDialog, AlertMessage, AlertService, DialogType, MessageSeverity } from "../services/alert.service";
import { AppTitleService } from "../services/app-title.service";
import { AppTranslationService } from "../services/app-translation.service";
import { AuthService } from "../services/auth.service";
import { ConfigurationService } from "../services/configuration.service";
import { DBkeys } from "../services/db-Keys";
import { EventService } from "../services/event.service";
import { LocalStoreManager } from "../services/local-store-manager.service";
import { NotificationService } from "../services/notification.service";
import { ScrollService } from "../services/scroll.service";
import { WindowRefService } from "../services/window-ref.service";
import { Utilities } from "../services/utilities";


const alertify: any = require("../assets/scripts/alertify.js");


@Component({
    selector: "sidder-app",
    template: require('./app.component.html'),
    // styles: [require('./app.component.css'), require('../styles.css'), require('../../../node_modules/primeng/resources/themes/bootstrap/theme.css'), require('../../../node_modules/primeng/resources/primeng.css')],
    styles: [require('./app.component.css'), require('../styles.css')],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {


    appverClass: string = "";
    dropdownmenuClass: string = "";
    trialDaysLeft: number = 0;
    isAppLoaded: boolean;
    isUserLoggedIn: boolean;
    shouldShowLoginModal: boolean;
    removePrebootScreen: boolean;
    newNotificationCount = 0;
    appTitle = "Sidder";
    appLogo = require("../assets/images/logo.png");
    isbackLoginToPrevious: boolean = false;

    stickyToasties: number[] = [];

    dataLoadingConsecutiveFailurs = 0;
    notificationsLoadingSubscription: any;

    @ViewChildren("loginModal,loginControl")
    modalLoginControls: QueryList<any>;

    isProcessing: boolean = false;
    loginModal: ModalDirective;
    loginControl: LoginComponent;
    applicationVersion: any = "";
    applicationVersionName: any = "";
    applicationTrialDays: number;
    isSidebarCollapse: boolean = false;
    private subscribers: Subscription[] = [];

    private _window: Window;

    get notificationsTitle() {
        let gT = (key: string) => this.translationService.getTranslation(key);

        if (this.newNotificationCount)
            return `${gT("app.Notifications")} (${this.newNotificationCount} ${gT("app.New")})`;
        else
            return gT("app.Notifications");
    }

    // ng-idle for session timeout log out user when user is inactive for certain time period
    idleTimer = "0";
    timedOut = false;
    displaySessionExpiredModal = false;
    idle_subsciption: Subscription;

    constructor(private storageManager: LocalStoreManager, private toastyService: ToastyService, private toastyConfig: ToastyConfig,
        private accountService: AccountService, private alertService: AlertService, private notificationService: NotificationService, private appTitleService: AppTitleService,
        private authService: AuthService, private translationService: AppTranslationService, public configurations: ConfigurationService, public router: Router, private winRef: WindowRefService, private idle: Idle, private keepalive: Keepalive,
        private scrollService: ScrollService, private eventService: EventService) {


        if (window.innerWidth <= 1024) {
            this.isSidebarCollapse = true;
        }

        this._window = winRef.nativeWindow;

        const paramSubscriber = router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.scrollService.scrollTop();
        });
        this.subscribers.push(paramSubscriber);

        storageManager.initialiseStorageSyncListener();

        translationService.addLanguages(["en", "fr", "de", "pt", "ar", "ko"]);
        translationService.setDefaultLanguage("en");

        this.toastyConfig.theme = "bootstrap";
        this.toastyConfig.position = "top-right";
        this.toastyConfig.limit = 100;
        this.toastyConfig.showClose = true;
        this.appTitleService.appName = this.appTitle;
        this.updateNLMomentFormate();
    }

    ngAfterViewInit() {
        const changeSubscriber = this.modalLoginControls.changes.subscribe((controls: QueryList<any>) => {
            controls.forEach(control => {
                if (control) {
                    if (control instanceof LoginComponent) {
                        this.loginControl = control;
                        this.loginControl.modalClosedCallback = () => this.loginModal.hide();
                    } else {
                        this.loginModal = control;
                        this.loginModal.show();
                    }
                }
            });
        });
    }

    // used to update the Moment Locale dateTime format or Translation
    private updateNLMomentFormate() {
        moment.updateLocale('nl-be', {
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                l: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                ll: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
            }
        });
    }

    onLoginModalShown() {
        this.alertService.showStickyMessage("Sessie verlopen", "Uw sessie is verlopen. Log alsjeblieft nogmaals in.", MessageSeverity.info);
    }

    onLoginModalHidden() {
        this.alertService.resetStickyMessage();
        this.loginControl.reset();
        this.shouldShowLoginModal = false;

        if (this.authService.isSessionExpired)
            this.alertService.showStickyMessage("Sessie verlopen", "Uw sessie is verlopen. Meld u opnieuw aan om uw sessie te verlengen.", MessageSeverity.warn);
    }

    onLoginModalHide() {
        this.alertService.resetStickyMessage();
    }

    ngOnInit() {


        this.isUserLoggedIn = this.authService.isLoggedIn;
        // 1 sec to ensure all the effort to get the css animation working is appreciated :|, Preboot screen is removed .5 sec later
        setTimeout(() => this.isAppLoaded = true, 1000);
        setTimeout(() => this.removePrebootScreen = true, 1500);

        setTimeout(() => {
            this.applicationVersion = this.accountService.applicationVersion;
            this.applicationVersionName = this.accountService.applicationVersionName;


            if (this.applicationVersionName == 'TEST' || this.applicationVersionName == 'DEVELOPMENT') {
                this.appverClass = "app-version";
            }



            if (this.isUserLoggedIn) {


                this.alertService.resetStickyMessage();

                // if (!this.authService.isSessionExpired)
                this.alertService.showMessage("Login", `Welkom terug ${this.userName}!`, MessageSeverity.default);
                // else
                //    this.alertService.showStickyMessage("Sessie Verlopen", "Wegens inactiviteit van de gebruiker !", MessageSeverity.warn);
            }
        }, 2000);

        this.alertService.getDialogEvent().subscribe(alert => this.showDialog(alert));
        this.alertService.getMessageEvent().subscribe(message => this.showToast(message, false));
        this.alertService.getStickyMessageEvent().subscribe(message => this.showToast(message, true));

        this.authService.reLoginDelegate = () => this.shouldShowLoginModal = true;

        const loginEvtSubscriber = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
            this.isUserLoggedIn = isLoggedIn;

            if (this.isUserLoggedIn) {
                this.initNotificationsLoading();

                // ng-idle configurate after user is logged in
                this.keepalive.request("api/Account/KeepHeartbeatAlive");
                // sets the ping interval time in seconds
                this.keepalive.interval(DBkeys.IDLE_KEEP_ALIVE_INTERVAL);
                // start keepAlive
                this.keepalive.start();

                // sets the Idle Name to avoid session confilict issues while using different enviornment of the same site
                this.idle.setIdleName(this.applicationVersionName);
                // sets an idle timeout in seconds
                this.idle.setIdle(DBkeys.IDLE_TIME);
                // sets a timeout period in seconds. after specified seconds of inactivity, the user will be considered timed out.
                this.idle.setTimeout(DBkeys.IDLE_TIME_OUT_DURATION);
                // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
                this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
                this.idle.setAutoResume(AutoResume.notIdle);

                this.idle_subsciption = this.idle.onTimeout.subscribe(() => {
                    this.keepalive.stop();
                    this.idle.stop();
                    this.timedOut = true;
                    this.logout();
                    this.displaySessionExpiredModal = false;
                    this.alertService.showStickyMessage("Sessie Verlopen !", "Wegens inactiviteit van de gebruiker", MessageSeverity.warn);
                    this.unsubscribe_idle();
                });

                this.idle.onIdleStart.subscribe(() => this.displaySessionExpiredModal = true);
                this.idle.onIdleEnd.subscribe(() => this.displaySessionExpiredModal = false);
                this.idle.onTimeoutWarning.subscribe((countdown) => this.idleTimer = " " + countdown + " ");
                this.reset();
                setTimeout(() => {
                    if (this.authService.currentUser != null) {
                        const expireDate = moment(this.authService.currentUser.ExpireDate);
                        const registerDate = moment(this.authService.currentUser.RegistrationDate);
                        // const daysDiff: number = expireDate.diff(registerDate, 'days'); // 1

                        if (this.authService.currentUser.IsTrial == true && expireDate.toDate() > new Date()) {
                            this.trialDaysLeft = expireDate.diff(moment(new Date()), 'days');
                        } else {
                            this.trialDaysLeft = 0;
                        }
                    }
                }, 2000);

                this.subscribers.push(loginEvtSubscriber);
            } else {
                this.unsubscribeNotifications();
                this.unsubscribe_idle();
            }

            setTimeout(() => {
                if (!this.isUserLoggedIn) {
                    this.alertService.showMessage("Sessie beëindigd!", "", MessageSeverity.default);
                }
            }, 500);
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                let url = (<NavigationStart>event).url;
                if (url !== url.toLowerCase()) {
                    this.router.navigateByUrl((<NavigationStart>event).url.toLowerCase());
                }
            }
        });
        const spinnerSubscriber = this.eventService.processingSpinnerStatus.subscribe(state => {
            this.isProcessing = state;
        }, error => {
            this.alertService.logError(error);
            this.isProcessing = false;
        });
        this.subscribers.push(spinnerSubscriber);
    }

    ngOnDestroy() {
        this.unsubscribeNotifications();
        this.idle.stop();
        this.unsubscribe_idle();
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    reset(): any {
        this.idle.watch();
        this.idleTimer = "0";
        this.displaySessionExpiredModal = this.timedOut = false;
    }

    private unsubscribeNotifications() {
        if (this.notificationsLoadingSubscription)
            this.notificationsLoadingSubscription.unsubscribe();
    }

    private unsubscribe_idle() {
        if (this.idle_subsciption) {
            this.idle_subsciption.unsubscribe();
        }
    }

    initNotificationsLoading() {
        this.notificationsLoadingSubscription = this.notificationService.getNewNotificationsPeriodically()
            .subscribe(notifications => {
                this.dataLoadingConsecutiveFailurs = 0;
                this.newNotificationCount = notifications.filter(n => !n.isRead).length;
            },
                error => {
                    this.alertService.logError(error);

                    if (this.dataLoadingConsecutiveFailurs++ < 20)
                        setTimeout(() => this.initNotificationsLoading(), 5000);
                    else
                        this.alertService.showStickyMessage("Laden Error", "Het laden van nieuwe meldingen van de server is mislukt!", MessageSeverity.error);
                });
    }

    markNotificationsAsRead() {
        const recentNotifications = this.notificationService.recentNotifications;
        if (recentNotifications.length) {
            this.notificationService.readUnreadNotification(recentNotifications.map(n => n.id), true)
                .subscribe(response => {
                    for (let n of recentNotifications) {
                        n.isRead = true;
                    }
                    this.newNotificationCount = recentNotifications.filter(n => !n.isRead).length;
                },
                    error => {
                        this.alertService.logError(error);
                        this.alertService.showMessage("Kennisgeving Error", "Marking read notifications failed", MessageSeverity.error);

                    });
        }
    }

    showDialog(dialog: AlertDialog) {
        alertify.set({
            labels: {
                ok: dialog.okLabel || "OK",
                cancel: dialog.cancelLabel || "Cancel"
            }
        });

        switch (dialog.type) {
            case DialogType.alert:
                alertify.alert(dialog.message);
                break;
            case DialogType.confirm:
                alertify.confirm(dialog.message, (e) => {
                    if (e) {
                        dialog.okCallback();
                    } else {
                        if (dialog.cancelCallback)
                            dialog.cancelCallback();
                    }
                });
                break;
            case DialogType.prompt:
                alertify.prompt(dialog.message, (e, val) => {
                    if (e) {
                        dialog.okCallback(val);
                    } else {
                        if (dialog.cancelCallback)
                            dialog.cancelCallback();
                    }
                }, dialog.defaultValue);
                break;
        }
    }

    showToast(message: AlertMessage, isSticky: boolean) {
        if (message == null) {
            for (let id of this.stickyToasties.slice(0)) {
                this.toastyService.clear(id);
            }
            return;
        }

        const toastOptions: ToastOptions = {
            title: message.summary,
            msg: message.detail,
            timeout: isSticky ? 0 : 4000
        };

        if (isSticky) {
            toastOptions.onAdd = (toast: ToastData) => this.stickyToasties.push(toast.id);

            toastOptions.onRemove = (toast: ToastData) => {
                const index = this.stickyToasties.indexOf(toast.id, 0);

                if (index > -1) {
                    this.stickyToasties.splice(index, 1);
                }

                toast.onAdd = null;
                toast.onRemove = null;
            };
        }

        switch (message.severity) {
            case MessageSeverity.default: this.toastyService.default(toastOptions); break;
            case MessageSeverity.info: this.toastyService.info(toastOptions); break;
            case MessageSeverity.success: this.toastyService.success(toastOptions); break;
            case MessageSeverity.error: this.toastyService.error(toastOptions); break;
            case MessageSeverity.warn: this.toastyService.warning(toastOptions); break;
            case MessageSeverity.wait: this.toastyService.wait(toastOptions); break;
        }
    }



    previousLogin() {
        this.authService.redirectToPreviousUserLogin();


        const impersonateSubscriber = this.authService.redirectToPreviousUserLogin()
            .subscribe(
                user => {
                    // Add Extra Details in User Object to update it in Session Storage

                    this.storageManager.deleteData(DBkeys.PREVIOUS_USER);
                    this.storageManager.deleteData(DBkeys.IS_PERSONATE);


                    this.authService.setExtraUserInfo(user, false);

                    //setTimeout(() => {
                    //    this.alertService.stopLoadingMessage();
                    //}, 500);


                    this.router.navigate(['users']);



                },
                error => {
                    this.alertService.stopLoadingMessage();

                    if (Utilities.checkNoNetwork(error)) {
                        this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    }
                    else {
                        let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

                        if (errorMessage)
                            this.alertService.showStickyMessage("Niet mogelijk om in te loggen", errorMessage, MessageSeverity.error, error);
                        else
                            this.alertService.showStickyMessage("Niet mogelijk om in te loggen", "Er is een fout opgetreden tijdens het inloggen. Probeer het later opnieuw.\nError: " + error.statusText || error.status, MessageSeverity.error, error);
                    }

                    setTimeout(() => {

                    }, 500);
                });

        this.subscribers.push(impersonateSubscriber);
    }

    logout() {
        this.trialDaysLeft = 0;
        this.idle.stop();
        this.authService.logout();
        this.authService.redirectLogoutUser();
    }

    // toggleProcessing(processState: boolean = false) {
    //     if (processState) {
    //         this.eventService.showProcessingSpinner();
    //     } else {
    //         this.eventService.hideProcessingSpinner();
    //     }
    // }

    onActivate(component) {


        if (this.storageManager.getDataObject<string>(DBkeys.PREVIOUS_USER) != null) {
            this.isbackLoginToPrevious = true;
            this.dropdownmenuClass = "dropdown-menu dropdown-menu210";
        }
        else {
            this.isbackLoginToPrevious = false;
            this.dropdownmenuClass = "dropdown-menu dropdown-menu176";
        }

    }

    getYear() {
        return new Date().getUTCFullYear();
    }

    get userName(): string {
        return this.authService.currentUser ? this.authService.currentUser.UserName : "";
    }

    get fullName(): string {
        return this.authService.currentUser ? this.authService.currentUser.FullName : "";
    }

    get CurrentLoginRoleName(): string {
        return this.authService.currentUser ? this.authService.currentUser.RoleId : "";
    }

    get canViewCustomers() {
        return this.accountService.userHasPermission(Permission.viewUsersPermission); // eg. viewCustomersPermission
    }

    get canViewOrders() {
        return true; // eg. viewOrdersPermission
    }

    get canviewUsers() {
        return this.accountService.userHasPermission(Permission.viewUsersPermission);
    }

    get canmanageUsers() {
        return this.accountService.userHasPermission(Permission.manageUsersPermission);
    }

    get canaddUsers() {
        return this.accountService.userHasPermission(Permission.addUsersPermission);
    }

    get caneditUsers() {
        return this.accountService.userHasPermission(Permission.editUsersPermission);
    }

    get candeleteUsers() {
        return this.accountService.userHasPermission(Permission.deleteUsersPermission);
    }

    get canlistUsers() {
        return this.accountService.userHasPermission(Permission.listUsersPermission);
    }

    get canapproveUsers() {
        return this.accountService.userHasPermission(Permission.approveUsersPermission);
    }

    get canviewRoles() {
        return this.accountService.userHasPermission(Permission.viewRolesPermission);
    }

    get canmanageRoles() {
        return this.accountService.userHasPermission(Permission.manageRolesPermission);
    }

    get canviewCustomers() {
        return this.accountService.userHasPermission(Permission.viewCustomersPermission);
    }

    get canmanageCustomers() {
        return this.accountService.userHasPermission(Permission.manageCustomersPermission);
    }

    get canmanageUsersMappingPermission() {
        return this.accountService.userHasPermission(Permission.manageUsersMappingPermission);
    }

    get canmanageCustomersMapping() {
        return this.accountService.userHasPermission(Permission.manageCustomersMappingPermission);
    }

    get canaddCustomers() {
        return this.accountService.userHasPermission(Permission.addCustomersPermission);
    }

    get caneditCustomers() {
        return this.accountService.userHasPermission(Permission.editCustomersPermission);
    }

    get candeleteCustomers() {
        return this.accountService.userHasPermission(Permission.deleteCustomersPermission);
    }

    get canlistCustomers() {
        return this.accountService.userHasPermission(Permission.listCustomersPermission);
    }

    get canviewDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.viewDeliveryAddressPermission);
    }

    get canmanageDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.manageDeliveryAddressPermission);
    }

    get canaddDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.addDeliveryAddressPermission);
    }

    get caneditDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.editDeliveryAddressPermission);
    }

    get candeleteDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.deleteDeliveryAddressPermission);
    }

    get canlistDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.listDeliveryAddressPermission);
    }

    get canviewSuppliers() {
        return this.accountService.userHasPermission(Permission.viewSuppliersPermission);
    }

    get canmanageSuppliers() {
        return this.accountService.userHasPermission(Permission.manageSuppliersPermission);
    }

    get canaddSuppliers() {
        return this.accountService.userHasPermission(Permission.addSuppliersPermission);
    }

    get caneditSuppliers() {
        return this.accountService.userHasPermission(Permission.editSuppliersPermission);
    }

    get candeleteSuppliers() {
        return this.accountService.userHasPermission(Permission.deleteSuppliersPermission);
    }

    get canlistSuppliers() {
        return this.accountService.userHasPermission(Permission.listSuppliersPermission);
    }

    get canmanageElectricityDashboard() {
        return this.accountService.userHasPermission(Permission.manageElectricityDashboardPermission);
    }

    get canelectricityExport() {
        return this.accountService.userHasPermission(Permission.electricityExportPermission);
    }

    get canelectricityOverview() {
        return this.accountService.userHasPermission(Permission.electricityOverviewPermission);
    }

    get canelectricityContractAdd() {
        return this.accountService.userHasPermission(Permission.electricityContractAddPermission);
    }

    get canelectricityContractEdit() {
        return this.accountService.userHasPermission(Permission.electricityContractEditPermission);
    }

    get canelectricityContractDelete() {
        return this.accountService.userHasPermission(Permission.electricityContractDeletePermission);
    }

    get canelectricityContractView() {
        return this.accountService.userHasPermission(Permission.electricityContractViewPermission);
    }

    get canelectricityContractList() {
        return this.accountService.userHasPermission(Permission.electricityContractListPermission);
    }

    get caninjectionContractAdd() {
        return this.accountService.userHasPermission(Permission.injectionContractAddPermission);
    }

    get caninjectionContractEdit() {
        return this.accountService.userHasPermission(Permission.injectionContractEditPermission);
    }

    get caninjectionContractDelete() {
        return this.accountService.userHasPermission(Permission.injectionContractDeletePermission);
    }

    get canelinjectionContractView() {
        return this.accountService.userHasPermission(Permission.injectionContractViewPermission);
    }

    get caninjectionContractList() {
        return this.accountService.userHasPermission(Permission.injectionContractListPermission);
    }

    get canmanageGASDashboard() {
        return this.accountService.userHasPermission(Permission.manageGasDashboardPermission);
    }

    get canGASExport() {
        return this.accountService.userHasPermission(Permission.gasExportPermission);
    }

    get canGASOverview() {
        return this.accountService.userHasPermission(Permission.gasOverviewPermission);
    }

    get canGASContractAdd() {
        return this.accountService.userHasPermission(Permission.gasContractAddPermission);
    }

    get canGASContractEdit() {
        return this.accountService.userHasPermission(Permission.gasContractEditPermission);
    }

    get canGASContractDelete() {
        return this.accountService.userHasPermission(Permission.gasContractDeletePermission);
    }

    get canGASContractView() {
        return this.accountService.userHasPermission(Permission.gasContractViewPermission);
    }

    get canGASContractList() {
        return this.accountService.userHasPermission(Permission.gasContractListPermission);
    }

    get canmanageDashboardPermission() {
        return this.accountService.userHasPermission(Permission.manageDashboardPermission);
    }

    get cangasImportPermission() {
        return this.accountService.userHasPermission(Permission.gasImportPermission);
    }

    get canoilOverview() {
        return this.accountService.userHasPermission(Permission.oilOverviewPermission);
    }

    get cangastwoOverview() {
        return this.accountService.userHasPermission(Permission.GasTwoOverviewPermission);
    }

    get cangasthreeOverview() {
        return this.accountService.userHasPermission(Permission.GasThreeOverviewPermission);
    }


    get cancoalOverview() {
        return this.accountService.userHasPermission(Permission.CoalOverviewPermission);
    }

    get cancotwoOverview() {
        return this.accountService.userHasPermission(Permission.CoTwoOverviewPermission);
    }

    get canbelpexOverview() {
        return this.accountService.userHasPermission(Permission.belpexOverviewPermission);
    }



}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/app.component.ts